module.exports = __webpack_public_path__ + "img/18.107.B.a10471da.png";